import * as Yup from 'yup';

const walletTransactionSchema = Yup.object().shape({
  paymentMethod: Yup.string()
    .oneOf(['creditNote', 'reduceNote'])
    .required('Payment method is required.'),
  amount: Yup.number()
    .required('Amount is required.')
    .typeError('Must be Number')
    .moreThan(0, 'Amount must be greater than 0')
    .when('paymentMethod', {
      is: 'reduceNote',
      then: (schema) =>
        schema.test(
          'max-balance',
          'Reduce amount cannot be greater than total credit.',
          function (value) {
            const balance = Number(this.parent.currentBalance || 0);
            if (value == null || Number.isNaN(Number(value))) return true;
            return Number(value) <= balance;
          }
        ),
    }),
});

export default walletTransactionSchema;
